/* eslint-disable react/prop-types */
import { listToString } from "@/common/announcement-helper";
import CumulativeAnnoucementsComponent from "./cumulative-announcements";

function CumulativeAnnoucements({ announcement, announcements, admin, offer }) {
  const { sector } = announcement;
  return (
    <CumulativeAnnoucementsComponent
      correlatedAnnouncements={announcements}
      sectors={listToString(sector)}
      admin={admin}
      offer={offer}
    />
  );
}

export default CumulativeAnnoucements;
